/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Manufacturer
 */
export interface Manufacturer {
    /**
     * 
     * @type {string}
     * @memberof Manufacturer
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof Manufacturer
     */
    name: string;
    /**
     * When editable is true, the entry can be updated. If false the Data is imported and not changeable
     * @type {boolean}
     * @memberof Manufacturer
     */
    readonly editable?: boolean;
}

/**
 * Check if a given object implements the Manufacturer interface.
 */
export function instanceOfManufacturer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ManufacturerFromJSON(json: any): Manufacturer {
    return ManufacturerFromJSONTyped(json, false);
}

export function ManufacturerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Manufacturer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'editable': !exists(json, 'editable') ? undefined : json['editable'],
    };
}

export function ManufacturerToJSON(value?: Manufacturer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

